<template>
  <footer class="footer">
    <div class="container">
      <p class="mb-6 px-4" v-if="$whitelabel.short.toLowerCase() === 'adac'">
        Der ADAC Südbayern e.V. vermittelt die Hotelgutscheine in Kooperation mit der SST Touristik Vertrieb GmbH -
        unserem Partner. Die Akquirierung der Hotelgutscheine und die Abwicklung der Bezahlung erfolgt durch unseren
        Partner. Der ADAC Südbayern e.V. ist verantwortlich für die Erstellung der
        Website <a href="https://www.adac-hotelgutschein.de">www.adac-hotelgutschein.de.</a>
      </p>
      <div class="columns is-multiline u-is-vend m-0">
        <div class="column is-12-tablet is-3-widescreen has-text-centered has-text-left-widescreen">
          <a href="/" class="is-block" v-if="$whitelabel.showFooterLogo" aria-label="Go back to Homepage">
            <img class="navbar-brand__logo" v-lazy="$whitelabel.logoFooter" :alt="$whitelabel.storeName" loading="lazy"
              fetchpriority="low" />
          </a>
          © {{ $whitelabel.company }}
        </div>
        <div class="column is-12-tablet is-9-widescreen has-text-right-widescreen has-text-centered ">
          <ul class="is-flex  is-flex-wrap-wrap is-flex-tablet footer-nav">
            <li v-if="$whitelabel.short.toLowerCase() === 'adac'"><a
                class=" is-block-mobile is-block-tablet footer-nav-link"
                href="https://www.adac-suedbayern.de/reisenewsletter-formular" target="_blank"
                title="ADAC Reise-Newsletter" rel="noopener">ADAC Reise-Newsletter</a></li>
            <li>
              <router-link :to="{ name: 'accessibility' }" class=" is-block-mobile is-block-tablet footer-nav-link">{{
                $t('accessibility.headline-short') }}</router-link>
            </li>
            <li v-for="(page, idx) in menu.footer" :key="idx">
              <router-link :to="{ name: 'markdown-page', params: { key: page.slug } }"
                class="is-block-mobile is-block-tablet footer-nav-link">{{ page.menu }}</router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="is-hidden-desktop has-text-centered">
        <a class="is-inline-block" v-if="$whitelabel.supportPhone" :href="`tel:${$whitelabel.supportPhone}`"><b-icon
            icon="phone" size="is-small" custom-class="fa-flip-horizontal"></b-icon>&nbsp;&nbsp;{{
              $whitelabel.supportPhone }}</a>
        &nbsp; &nbsp;
        <a class="is-inline-block" v-if="$whitelabel.supportMail" :href="`mailto:${$whitelabel.supportMail}`"><b-icon
            icon="envelope" size="is-small"></b-icon>&nbsp;&nbsp;{{ $whitelabel.supportMail }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Footer',
  components: {},
  computed: {
    ...mapGetters({
      menu: 'menu',
    }),
  },
  props: {},
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 1023px) {
  .footer {
    padding-bottom: 5rem;
  }
}

.footer-nav {
  justify-content: center;
}

.footer-nav-link {
  padding: 0.5rem;
}

@media screen and (min-width: 1216px) {
  .footer-nav {
    justify-content: flex-end;
  }

  .footer-nav-link {
    padding: 0 0.75rem;
  }
}
</style>
